import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  document?: string;
  phone?: string;
  active: boolean;
  role?: string;
}

export const userService = {
  getAll: (params?: any) => api.get(API_ENDPOINTS.USERS.INDEX, { params }),
  
  create: (data: any) => 
    api.post(API_ENDPOINTS.USERS.STORE, data),
  
  update: (id: number, data: any) => 
    api.put(API_ENDPOINTS.USERS.UPDATE(id), data),
    
  activate: (id: number) => 
    api.post(API_ENDPOINTS.USERS.ACTIVATE(id)),
    
  deactivate: (id: number) => 
    api.post(API_ENDPOINTS.USERS.DEACTIVATE(id)),
};
